import { DateStringNumber, Nullable } from "common/records";
import { paymentTermBreakdownFromJSON, PaymentTermBreakdownRecord } from "common/records/PaymentTermBreakdown";
import { IEstimatePaymentTermItemData, PaymentTermItemTypes } from "common/records/PaymentTermItem";
import { Record } from "immutable";

export const paymentTermFromJSON = (json: Partial<IPaymentTermData>): PaymentTermRecord => {
  const record: IPaymentTermRecord = { ...(json as any) };

  record.breakdown = paymentTermBreakdownFromJSON(json.breakdown || {});

  return new PaymentTermRecord(record);
};

export const paymentTermToJSON = (record: PaymentTermRecord) => {
  const json = record.toJS() as Partial<IPaymentTermData>;

  return json;
};

export const paymentTermTemplateData = (
  id: number,
  org_id: Nullable<number>,
  downPaymentUuid: string,
  remainingBalanceUuid: string,
  amount: number,
) => {
  const data: Partial<IPaymentTermData> = {
    breakdown: {
      items: [
        {
          amount,
          calculated: 0,
          description: "Down Payment",
          paymentMethod: "cash",
          type: "amount",
          uuid: downPaymentUuid,
        },
        {
          amount: 100,
          calculated: 0,
          description: "Remaining Balance",
          paymentMethod: "financed",
          type: "percent",
          uuid: remainingBalanceUuid,
        },
      ],
    },
    description: "Price Presentation",
    id,
    name: "Price Presentation",
    org_id,
  };

  return paymentTermFromJSON(data);
};

export interface IPaymentTermData {
  id: number;
  name: string;
  description: string;
  breakdown: { items: IEstimatePaymentTermItemData[]; kind?: PaymentTermItemTypes };
  org_id: Nullable<number>;
  created_at: DateStringNumber;
  updated_at: DateStringNumber;
  sort_order: Nullable<number>;
}

export interface IPaymentTermRecord {
  id: number;
  name: string;
  description: string;
  breakdown: PaymentTermBreakdownRecord;
  org_id: Nullable<number>;
  sort_order: Nullable<number>;
}

const defaultPaymentTermProps: IPaymentTermRecord = {
  id: 0,
  name: "",
  description: "",
  breakdown: paymentTermBreakdownFromJSON({}),
  org_id: null,
  sort_order: null,
};

export class PaymentTermRecord extends Record(defaultPaymentTermProps) implements IPaymentTermRecord {}
